import React from 'react';

import { CheckCircleIcon, NetworkIcon, ActivityIcon } from 'components/common/Icons';

const ITEMS = [
  { label: 'Everything', icon: CheckCircleIcon, text: 'Applies to all current and future tenants and sensors.' },
  { label: 'Tenant', icon: NetworkIcon, text: 'Applies to all current and future sensors under the selected tenant.' },
  { label: 'Sensor', icon: ActivityIcon, text: 'Applies only to the selected sensor(s).' },
];

const Help = () => (
  <div className="flex flex-col gap-3 w-1/2 mx-3 old-text-sm">
    {ITEMS.map(({ label, icon: Icon, text }) => (
      <div key={label}>
        <div className="flex items-center gap-1.5 font-semibold mb-0.5">
          <Icon aria-hidden />
          {label}
        </div>
        <div className="color-text-subtle ml-6">{text}</div>
      </div>
    ))}
  </div>
);

export default React.memo(Help);
